import List from './List'
import Create from './Create'
import View from './View'
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch
} from "react-router-dom";
import { useAuth } from '../../../../business/authProvider';

const PayeeRoutes = () => {
  let auth = useAuth()
  let { path, url } = useRouteMatch();
  const authRoles= auth.roles;
  return (<Switch>
    {(auth.permission || authRoles['get_permissions_roles']) ? <Route path={`${url}/list`} component={List} /> : null}
    {(auth.permission || authRoles['post_permissions_role']) ? <Route path={`${url}/create`} component={Create} /> : null}
    {(auth.permission || authRoles['patch_permissions_role_role_id']) ? <Route path={`${url}/:role_id/edit`} component={Create} /> : null}
    {(auth.permission || authRoles['get_permissions_role_role_id']) ? <Route path={`${url}/:role_id/view`} component={View} /> : null}
    <Route path={'*'}>
      <Redirect to={`${url}/list`} />
    </Route>
  </Switch>
  )
}
export default PayeeRoutes